module.exports = __webpack_public_path__ + "img/nodata.0a7ad880.jpg";